import React, { FC, ReactNode, useMemo } from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import { useApolloClient } from '@apollo/client';

import { createStore } from 'application/store';

import { ensureNormalizedCacheObjectClient } from './utils';

const StoreProvider: FC<{ children?: ReactNode }> = ({ children }) => {
  const client = useApolloClient();

  const store = useMemo(() => {
    const typedClient = ensureNormalizedCacheObjectClient(client);
    const result = createStore(typedClient);

    return result;
  }, [client]);

  return <ReduxProvider store={store}>{children}</ReduxProvider>;
};

export default StoreProvider;
